import React, {useEffect, useState} from 'react'
import {Button, Confirm, Icon, Table, Loader, Menu, Input} from 'semantic-ui-react';
import {deleteCourseCategories, fetchCourseCategories} from "../../../../redux/actions";
import {CourseCategoryForm} from "./CourseCategoryForm";

const token = sessionStorage.getItem('Token')

const NavBar = ({setShowForm}) => {
    return (
        <Menu secondary>
            <Menu.Item
                onClick={() => setShowForm(true)}
                content={'Criar categoria'}
            >
            </Menu.Item>
            <Menu.Menu position='right'>
                <Menu.Item>
                    <Input icon='search' placeholder='Search...'/>
                </Menu.Item>
            </Menu.Menu>
        </Menu>
    );
}

export const Categories = () => {

    const [showDelete, setShowDelete] = useState({
        open: false
    })
    const [showForm, setShowForm] = useState({
        open: false
    })
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    const handleOpenDelete = (id = 0) => {
        setShowDelete({
            open: id !== 0,
            id
        })
    }

    const handleOpenForm = (open, id = 0, name= '', product= false) => {
        setShowForm({
            open,
            id,
            name,
            product
        })
    }

    const handleDelete = async () => {
        try {
            await deleteCourseCategories({id: showDelete.id});

            await fetchData();

        } catch (e) {
            console.log('error', e);
        }
    }

    const fetchData = async () => {

        handleOpenDelete();
        handleOpenForm(false)
        setLoading(true);

        try {
            const res = await fetchCourseCategories({active: 1});

            setItems(res.data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        async function getData(){
            await fetchData();
        }
        // noinspection JSIgnoredPromiseFromCall
        getData();
    }, [token]);

    return (
        <React.Fragment>
            <NavBar setShowForm={handleOpenForm} />
            <Confirm
                size={'tiny'}
                header={'Atenção'}
                content={'Deseja realmente efetuar esta exclusão?'}
                open={showDelete.open}
                cancelButton={'Não'}
                confirmButton={'Sim, quero excluir!'}
                onCancel={() => handleOpenDelete()}
                onConfirm={() => handleDelete()}
            />
            <CourseCategoryForm show={showForm.open} item={showForm} onCancel={() => handleOpenForm(false)} onSuccess={() => fetchData()}/>
            <Loader active={loading} inline/>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Nome</Table.HeaderCell>
                        <Table.HeaderCell width={3}>Tipo</Table.HeaderCell>
                        <Table.HeaderCell width={3} textAlign={"center"}>Ações</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        items.map(item => {
                            return (
                                <Table.Row key={`row-${item.id}`}>
                                    <Table.Cell>
                                        {item.name}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {item.product ? 'Produto' : 'Curso'}
                                    </Table.Cell>
                                    <Table.Cell textAlign={"center"}>
                                        <Button.Group>
                                            <Button icon onClick={()=>handleOpenForm(true, item.id, item.name, item.product)}>
                                                <Icon name='edit'/>
                                            </Button>
                                            <Button icon onClick={() => handleOpenDelete(item.id)}>
                                                <Icon name='trash'/>
                                            </Button>
                                        </Button.Group>
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })
                    }
                </Table.Body>
            </Table>
        </React.Fragment>
    )
}